import { render } from "./InvoiceOrders.vue?vue&type=template&id=182bdf0a&scoped=true&ts=true"
import script from "./InvoiceOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceOrders.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceOrders.vue?vue&type=style&index=0&id=182bdf0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182bdf0a"],['__file',"resources/js/vue/domain/invoice/components/shared/InvoiceOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "182bdf0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('182bdf0a', __exports__)) {
    api.reload('182bdf0a', __exports__)
  }
  
  module.hot.accept("./InvoiceOrders.vue?vue&type=template&id=182bdf0a&scoped=true&ts=true", () => {
    api.rerender('182bdf0a', render)
  })

}


export default __exports__